import React from "react";
import { useTranslation } from "react-i18next";
import Highlighter from "react-highlight-words";
import { ChevronRight, MoreVertical } from "lucide-react";
import { SINGLE_VALUE } from "./constants";
import SubMenu from "./SubMenu";
import BranchItem from "./BranchItem";
import { toggleOutlet } from "./helpers";

const OutletItem = ({
  outlet,
  region,
  expandedRegions,
  expandedOutlets,
  expandedBranches,
  searchTerm,
  subMenuID,
  setSubMenuID,
  showAllTerminals,
  handleToggleShowAll,
  setCurrentBranch,
  setInfoPopupOpen,
  setExpandedOutlets,
  setExpandedBranches,
  outletActions,
  branchActions,
  terminalActions,
}) => {
  const { t: translate } = useTranslation();
  const hasBranches = !!outlet.branches.length;

  return (
    <div
      key={outlet.id}
      className="my-1 flex flex-col p-2 pl-6 py-4 last-of-type:pb-0 last-of-type:mb-0 rounded"
    >
      <div className="flex justify-between items-center">
        <div
          data-testid={`outlet-${outlet.id}`}
          onClick={() =>
            hasBranches &&
            toggleOutlet({
              outletId: outlet.id,
              setSubMenuID,
              setExpandedOutlets,
            })
          }
          className="text-lg font-semibold cursor-pointer flex items-center flex-1"
        >
          <span
            className={`transform transition-transform duration-300 dark:text-white ${
              expandedOutlets[outlet.id] ? "rotate-90" : "rotate-0"
            }`}
          >
            <ChevronRight size={20} />
          </span>
          <div className="flex ml-2 gap-2 items-baseline">
            <span className=" dark:text-white text-gray-800">
              {" "}
              <Highlighter
                highlightClassName="text-red-500 bg-transparent"
                searchWords={[searchTerm]}
                autoEscape={true}
                textToHighlight={outlet.name}
              />
            </span>
            <span className=" text-xs text-gray-400">
              {outlet.branches.length} {translate("hierarchy.branch")}
              {outlet.branches.length > SINGLE_VALUE ? "es" : ""}
            </span>
          </div>
        </div>
        <button
          className="relative dark:text-white"
          onClick={() => setSubMenuID(outlet.id)}
          data-testid={`outlet-action-${outlet.id}`}
        >
          <MoreVertical size={20} />
          {subMenuID === outlet.id &&
            subMenuID !== null &&
            expandedRegions[region.id] && (
              <SubMenu
                id={outlet.id}
                type="area"
                addType="outlet"
                actions={outletActions}
                parent={outlet}
                onClose={() => setSubMenuID(null)}
              />
            )}
        </button>
      </div>
      {expandedOutlets[outlet.id] && (
        <div
          className={`ml-[11px] transition-all border-l-2 border-gray-200 duration-500`}
        >
          {outlet.branches.map((branch) => (
            <BranchItem
              key={branch.id}
              branch={branch}
              outlet={outlet}
              region={region}
              expandedBranches={expandedBranches}
              expandedOutlets={expandedOutlets}
              searchTerm={searchTerm}
              subMenuID={subMenuID}
              setSubMenuID={setSubMenuID}
              showAllTerminals={showAllTerminals}
              handleToggleShowAll={handleToggleShowAll}
              setCurrentBranch={setCurrentBranch}
              setInfoPopupOpen={setInfoPopupOpen}
              setExpandedBranches={setExpandedBranches}
              branchActions={branchActions}
              terminalActions={terminalActions}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default OutletItem;
